"use client"

import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../store"
import geoInfo from "../../utils/geoInfo"
import { searchFunction } from "../../commonfunctions/searchFunction"
import DropdownButtonForSearch from "../../Dropdowns/DropdownButtonForSearch"
import InputLabel from "../../inputfields/InputLabel"
import Image from "../../images/Image"
import DropDownModel from "../../Dropdowns/DropDownModel"
import useTranslation from "../../CustomHooks/useTranslation"
import ToolTip from "../../ToolTip/ToolTip"
import { getFirefoxCssFix } from "../../commonfunctions/getFirefoxCssFix"
import CheckBoxWithLabel from "../../checkbox/CheckBoxWithLabel"
import { selectAllProvinces, setRegion, toggleProvince } from "../../../store/slices/businessAreasSlice"



export default function ComponentBusinessAssignedArea({ }) {
  const { region, provinces } = useSelector((state: RootState) => state.businessAreas.areas)
  const dispatch = useDispatch();
  const regionList = [...new Set(geoInfo.map((item) => item['region_name']))]
  const [regions, setRegions] = useState(regionList)
  const [isOpen, setIsOpen] = useState(false)
  const { translate } = useTranslation({})
  const [provincesList, setProvincesList] = useState<string[]>([])

  const handleRegionChange = (value: string) => {
    dispatch(setRegion(value))
    dispatch(selectAllProvinces([]))
    setProvincesList([...new Set(geoInfo.filter(item => item["region_name"] === value).map(item => item.province))]);
  }

  const handleSearchValue = (value: string) => {
    setRegions(searchFunction(value, regionList))
  }
  const handleSelectAll = () => {
    dispatch(selectAllProvinces(provincesList));
  }
  const handleCheckbox = (value: string) => {
    dispatch(toggleProvince(value));
  }
  useEffect(() => {
    if (region) {
      setProvincesList([...new Set(geoInfo.filter(item => item["region_name"] === region).map(item => item.province))]);
    }
  }, [region])

  return (
    <div className="bg-blue-50 pt-4 px-4 rounded-lg flex gap-4 justify-between items-center w-full">
      <div className="flex flex-wrap gap-4 w-full">
        <DropdownButtonForSearch
          labelName="Region"
          id="Region"
          tabIndex={1}
          required={false}
          options={regions}
          selectedValue={region}
          onChange={(_, value) => handleRegionChange(value)} // Ensure `id` is passed as a number
          handleSearchValue={handleSearchValue}
          modalStyle={' mb-5 w-1/3'}
          className={'w-full'}
        />
        <DropDownModel isOpen={isOpen} handleClose={setIsOpen} modalStyle={'w-1/3'}>
          <InputLabel labelName={'Province (State)'} id={'province'} />
          <button
            // ref={buttonRef}
            type="button"
            data-testid={'id'}
            className={`bg-white w-full h-14 py-5 pr-[15px] disabled:bg-disable_fill disabled:border-disable_stroke pl-2.5 focus:pl-[9px] border rounded-lg text-subTitle outline-none focus:border-2 flex justify-between items-center ${false ? "border-negative" : "border-P_light_active"
              }`}
            disabled={region === ''}
            onClick={() => setIsOpen(!isOpen)}
          // tabIndex={tabIndex}
          >
            <span
              className={`${provinces.length > 0 ? "text-primary_text" : "text-secondary_text"} group w-[95%] truncate flex flex-1 text-subTitle`}
            >
              <p className=" truncate">{provinces.length > 0 ? `${provinces.length} selected` : translate(`Select ${'Province (State)'.toLowerCase()}`)}</p>
              {provinces.length > 0 && <ToolTip ToolTipItem={provinces.toString() || ""} top="top-[1rem]" />}
            </span>
            <Image src={false ? "arrow_light" : "dropdown-down-arrow"} />
          </button>
          {isOpen && (
            <div className="absolute w-full mt-1 rounded-[8px]  max-h-[240px] bg-white border border-P_light_active shadow-lg z-50">
              <p className="flex items-center text-primary_text text-subTitle mx-4 my-2 px-2 py-1 hover:bg-information_light hover:rounded-lg border-b " onClick={handleSelectAll}>
                <CheckBoxWithLabel id='select-all' fontWeight="font-medium" label="Select All" handelCheckBox={handleSelectAll} checked={provincesList.length === provinces.length} isBusinessAssignedArea={true} />
              </p>
              <ul className={` overflow-y-scroll mr-1 z-50 overflow-x-hidden ${getFirefoxCssFix(
                "scroll"
              )} scroll-auto pl-3.5 pr-2 pb-4`}>

                {provincesList.map((option: string) => (
                  <li
                    key={option}
                    className="flex items-center px-2 py-1 hover:bg-information_light hover:rounded-lg"
                    onClick={() => handleCheckbox(option)}
                  >
                    <CheckBoxWithLabel fontWeight="font-medium" id={option} isBusinessAssignedArea={true} label={option} handelCheckBox={handleCheckbox} checked={provinces.includes(option)} />

                  </li>
                ))}
              </ul>
            </div>
          )}
        </DropDownModel>
      </div >
    </div >
  )
}
